import { Trip } from "../../DataStructures/Trip/Trip";

export class TripColorMap{
    
    trips = [

    ];
    static colors = [
        'blue',
        'red',
        'green',
        'yellow',
        'orange',
        'purple'
    ];
    constructor(){

    }

    mapColors(trips:Array<Trip>){
        var counter = 0;
        trips.forEach(t =>{
            if(counter > TripColorMap.colors.length - 1){
                counter = 0;
            }
            t.color = `usermarker_${TripColorMap.colors[counter]}.png`;
            counter += 1;
        });
        return trips;
    }
}